import { render, staticRenderFns } from "./ResDialog.vue?vue&type=template&id=7af6f6c2&scoped=true"
import script from "./ResDialog.vue?vue&type=script&lang=js"
export * from "./ResDialog.vue?vue&type=script&lang=js"
import style0 from "./ResDialog.vue?vue&type=style&index=0&id=7af6f6c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af6f6c2",
  null
  
)

export default component.exports